import React from 'react';

const size_int = 4;
const size_unit = 'rem';

const burger_styles = {
  size: size_int + size_unit, // Size of Hamburger
  middle: (size_int / 2) + size_unit, // For middle line in hamburger - should be 1/2 of size.
  offset: (size_int / 4) + size_unit, // Top and bottome offset.
  top: 1 + size_unit,
  right: 3 + size_unit,
  transition_time: '250ms',
  thickness: '2px',
  color: '#010101'
};

const Hamburger = ({ onClick, clickState }) => (
  <button className= {
      (clickState)
      ? 'hamburger hamburger_htx active'
      : 'hamburger hamburger_htx'
    } onClick={onClick}>
    <span>Menu</span>
    <style jsx>{`
      .hamburger {
        width: ${burger_styles.size};
        height: ${burger_styles.size};
        top: ${burger_styles.top};
        right: ${burger_styles.right};
        display: block;
        position: absolute;
        overflow: hidden;
        margin: 0;
        padding: 0;
        font-size: 0;
        text-indent: -9999px;
        appearance: none;
        box-shadow: none;
        border-radius: none;
        border: none;
        transition: all 350ms ease;
        background-color: rgba(0, 0, 0, 0);
        cursor: pointer;
        z-index: 12000;
      }
      .hamburger:focus {
        outline: none;
      }
      .hamburger span {
        transition: all 350ms ease;
        display: block;
        position: absolute;
        top: ${burger_styles.middle};
        left: 0;
        right: 0;
        height: ${burger_styles.thickness};
        background: ${burger_styles.color};
      }
      .hamburger span::before,
      .hamburger span::after {
        transition: all 350ms ease;
        position: absolute;
        display: block;
        left: 0;
        width: 100%;
        height: ${burger_styles.thickness};
        background-color: ${burger_styles.color};
        content: "";
      }
      .hamburger span::before {
        top: ${burger_styles.offset};
      }
      .hamburger span::after {
        bottom: ${burger_styles.offset};
      }
      .hamburger_htx {
        background-color: rgba (255, 255, 255, 0);
      }
      .hamburger_htx span {
        transition: background 0s ${burger_styles.size};
      }
      .hamburger_htx span::before,
      .hamburger_htx span::after {
        transition-duration: ${burger_styles.size};, ${burger_styles.size};
        transition-delay: ${burger_styles.size};, 0s;
      }
      .hamburger_htx span::before {
        transition-property: top, transform;
      }
      .hamburger_htx span::after {
        transition-property: bottom, transform;
      }
      .hamburger_htx.active span {
        background: none;
      }
      .hamburger_htx.active span::before {
        top: 0;
        transform: rotate(45deg);
      }
      .hamburger_htx.active span::after {
        bottom: 0;
        transform: rotate(-45deg);
      }
      .hamburger_htx.active span::before,
      .hamburger_htx.active span::after {
        transition-delay: 0s, ${burger_styles.size};
      }
    `}</style>
  </button>
);

export default Hamburger;



// WEBPACK FOOTER //
// ./src/components/header/Hamburger.js